import { Rows2, Rows4 } from 'lucide-react';
import type { TriageDensity } from '../../hooks/useTriageDensity';
import { Tabs, TabsList, TabsTrigger } from '../../ui/tabs';

interface TriageDensityToggleProps {
  value: TriageDensity;
  onChange: (density: TriageDensity) => void;
}

/** Comfortable/dense row-height toggle for Triage — pairs with `useTriageDensity`. */
export function TriageDensityToggle({ value, onChange }: TriageDensityToggleProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as TriageDensity)}>
      <TabsList>
        <TabsTrigger value="comfortable" className="gap-1.5" title="Comfortable cards">
          <Rows2 className="h-3.5 w-3.5" />
          <span className="sr-only">Comfortable</span>
        </TabsTrigger>
        <TabsTrigger value="dense" className="gap-1.5" title="Dense rows">
          <Rows4 className="h-3.5 w-3.5" />
          <span className="sr-only">Dense</span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
